<ivy-modal-component
        [titleOptions]="title$ | async"
        [buttons]="buttons$ | async"
        [templateRefContent]="modalBody"
      >
      </ivy-modal-component>

      <ng-template #modalBody>
        <span> {{message$ | async}} </span>
      </ng-template>